import React from 'react';
import { Wrapper } from './styledComponent';

function LoginWrapper({ children, bg, bg1, bg2 }) {
	return (
		<Wrapper
			bg={`url(${bg}) no-repeat center center/cover`}
			bg1={`url(${bg1}) no-repeat center center/cover`}
			bg2={`url(${bg2}) no-repeat center center/cover`}>
			{children}
		</Wrapper>
	);
}

export default LoginWrapper;
